import { render, staticRenderFns } from "./sepehr.vue?vue&type=template&id=2043b638"
import script from "./sepehr.vue?vue&type=script&lang=js"
export * from "./sepehr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports